import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 商家
import login from '@/store/module/login'

export default new Vuex.Store(
  {
    modules: {
      login,
    },
    strict: false,
  }
)



// WEBPACK FOOTER //
// ./src/store/index.js